import React, { useEffect, useState } from 'react';
import { useIsAuthenticated } from './hooks/userIsAuthenticated';
import { registerLocale } from "react-datepicker";

import { LoginPage } from './pages/LoginPage';
import { HomePage } from './pages/HomePage';
import { StudiesPage } from './pages/StudiesPage';
import { TemplatesPage } from './pages/TemplatesPage';

import { Container,Row, Col, Nav, Alert} from 'react-bootstrap';
import { Link, Route, Routes } from 'react-router-dom';
import { UserInfo } from './components/UserInfo';
import { loadConfig } from './api/config';
import { useDispatch } from 'react-redux';
import { setConfig } from './store/configSlice';
import { routes } from './routes';
import { AutoMessagePage } from './pages/AutomessagePage';
import { ApiContext } from './components/ApiContext';
import { AccountsPage } from './pages/AccountsPage';
import { useDefaultLocale } from './hooks/useDefaultLocale';
import { BouncesPage } from './pages/BouncesPages';

interface AppProps {
  app_title: string;
}

export const App : React.FC<AppProps> = (props)=>{
  
  const isAuthenticated = useIsAuthenticated();
  const [loaded, setLoaded]= useState<boolean>(false);
  const [configError, setConfigError]= useState<unknown|undefined>(undefined);
  const defaultLocale = useDefaultLocale();
  const dispatch = useDispatch();

  registerLocale('default', defaultLocale);

  useEffect(()=> {
    if(loaded) {
      return;
    }
    setLoaded(true);
    const load = async ()=> {
      try {
        const conf = await loadConfig();
        dispatch(setConfig(conf));
        setLoaded(true);
      } catch(e) {
        console.log('config error', e);
        setConfigError(e);
      }
    };
    load();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaded]);

  if(!isAuthenticated) {
    return (
    <Container>
         <LoginPage/> 
   </Container>
    );
  }

  if(configError) {
    return <Container>
      <Alert variant="danger">
        <p>Unable to load config, is server running ?</p>
        <p>{JSON.stringify(configError) }</p>
      </Alert>
    </Container>

  }

  return (
    <Container fluid>
      <Row>
          <Col>
            <ApiContext/>
          </Col>
      </Row>
      <Row>
        <Col sm={1}>
          <Nav defaultActiveKey="/" className="flex-column">
            <Nav.Link as={Link}  to="/">Home</Nav.Link>
            <Nav.Link as={Link}  to={routes.accounts}>Accounts</Nav.Link>
            <Nav.Link as={Link}  to={routes.studies}>Studies</Nav.Link>
            <Nav.Link as={Link}  to={routes.automessages}>Newsletters</Nav.Link>
            <Nav.Link as={Link}  to={routes.templates}>Templates</Nav.Link>
            <Nav.Link as={Link}  to={routes.bounces}>Bounces</Nav.Link>
          </Nav>
          <UserInfo/>
        </Col>
        <Col>
          <Routes>
            <Route path={routes.home} element={<HomePage app_title={props.app_title} />} />
            <Route path={routes.studies} element={<StudiesPage/>}/>
            <Route path={routes.templates} element={<TemplatesPage/>} />
            <Route path={routes.bounces} element={<BouncesPage/>} />
            <Route path={routes.automessages} element={<AutoMessagePage/>} />
            <Route path={routes.accounts} element={<AccountsPage/>}/>
            <Route path={routes.login} element={<LoginPage/>} />
          </Routes>
        </Col>
      </Row>
    </Container>
  );
}

export default App;
